module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-api-management.a875c310.png";